// import lifeStyleApi from 'api/lifeStyleApi';
import { useMutation } from '@tanstack/react-query'
import businessBranchApi from 'api/businessBranchApi'
import customerApi from 'api/customerApi'
import { setAppSpinning } from 'app/appSlice'
import { thunkGetCustomerList } from 'features/Category/categorySlice'
import { FastField, Formik } from 'formik'
import CustomAntButton from 'general/components/Button/CustomAntButton'
import CustomButton from 'general/components/Button/CustomButton'
import VIToggleSwitch from 'general/components/eInvoiceComponents/VIToggleSwitch'
import KTFormGroup from 'general/components/Forms/KTFormGroup'
import KTFormInput, {
  KTFormInputType,
} from 'general/components/Forms/KTFormInput'
import KTFormSelect from 'general/components/Forms/KTFormSelect'
import AppData from 'general/constants/AppData'
import AppRegex, {
  REGEX_BUDGET_UNIT_CODE,
  REGEX_CMND_CCCD,
  REGEX_IDENTIFY,
} from 'general/constants/AppRegex'
import ToastHelper from 'general/helpers/ToastHelper'
import Global from 'general/utils/Global'
import Utils from 'general/utils/Utils'
import {
  useMutationGetCompanyInfo,
  useMutationRefreshCompanyInfo,
} from 'hooks/Mutations/useMutationGetCompanyInfo'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Button, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'

ModalEditBusnessBranch.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  onRefreshCustomerList: PropTypes.func,
  businessBranchItem: PropTypes.object,
  onExistDone: PropTypes.func,
}

ModalEditBusnessBranch.defaultProps = {
  show: false,
  onClose: null,
  onRefreshCustomerList: null,
  businessBranchItem: null,
  onExistDone: null,
}

/**
 *
 * @param {{
 * show: boolean,
 * onClose: function,
 * onRefreshCustomerList: function,
 * businessBranchItem: object,
 * onExistDone: function,
 * }} props
 * @returns
 */
///sss
function ModalEditBusnessBranch(props) {
  // MARK: --- Params ---
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const systemInvoiceType = useSelector((s) => s.auth?.activeInvoice)
  const { mutateAsync: refreshInfo, isPending: isRefreshingCompanyInfo } =
    useMutationRefreshCompanyInfo()
  const { mutateAsync: getInfo, isPending: isGettingCompanyInfo } =
    useMutationGetCompanyInfo()
  const {
    show,
    onClose,
    active,
    businessBranchItem,
    onExistDone,
    onRefreshCustomerList,
  } = props
  console.log('businessBranchItem', businessBranchItem)
  // MARK: --- Functions ---
  function handleClose() {
    if (onClose) {
      onClose()
    }
  }

  function handleExistDone() {
    if (onExistDone) {
      onExistDone()
    }
  }

  const { mutate } = useMutation({
    mutationKey: ['createCustomer', 'modalEditCustomer'],
    mutationFn: (params) => {
      const actionType = _.toLower(active)
      return actionType === 'add'
        ? businessBranchApi.update(params)
        : businessBranchApi.update({ ...params, type: 'edit' })
    },
    onMutate: () => dispatch(setAppSpinning(true)),
    onSettled: () => dispatch(setAppSpinning(false)),
    onError: (err) => {
      ToastHelper.showError(
        process.env.NODE_ENV === 'development' ? err?.message : 'Có lỗi xảy ra',
      )
    },
    onSuccess: (_res, variables) => {
      const resMess =
        active === 'ADD'
          ? 'Thêm mới địa điểm kinh doanh'
          : active === 'EDIT'
            ? 'Cập nhật thông tin địa điểm kinh doanh'
            : 'Nhân bản địa điểm kinh doanh ' + variables.name
      ToastHelper.showSuccess(`${resMess} thành công`)

      onRefreshCustomerList
        ? onRefreshCustomerList()
        : dispatch(thunkGetCustomerList(Global.gFiltersCustomerList))
      handleClose()
    },
  })

  const fetchInfoByTaxCode = async (type, formikProps) => {
    if (_.isEmpty(formikProps.getFieldProps('taxCode').value)) {
      ToastHelper.showError('Vui lòng nhập mã số thuế hoặc căn cước công dân')
      return
    }
    if (
      !AppRegex.taxCode.test(formikProps.getFieldProps('taxCode').value) &&
      !REGEX_IDENTIFY.REGEX_CCCD.test(formikProps.getFieldProps('taxCode'))
    ) {
      ToastHelper.showError(
        'Mã số thuế không hợp lệ hoặc căn cước công dân không hợp lệ',
      )
      return
    }
    let result
    let payload = { document_type: 'TAX' }
    if (AppRegex.taxCode.test(formikProps.getFieldProps('taxCode').value)) {
      payload.tax_code = formikProps.getFieldProps('taxCode').value
    } else if (
      REGEX_IDENTIFY.REGEX_CCCD.test(formikProps.getFieldProps('taxCode').value)
    ) {
      payload.owner_id_card_number = formikProps.getFieldProps('taxCode').value
    }
    if (type === TYPE.REFRESH) {
      result = await refreshInfo(payload)
    } else {
      result = await getInfo(payload)
    }

    if (!result) return
    const { document_data, message } = result.data
    if (message !== 'SUCCESSFULLY') {
      formikProps.getFieldHelpers('code').setValue('')
      formikProps.getFieldHelpers('name').setValue('')
      formikProps.getFieldHelpers('address').setValue('')
      formikProps.getFieldHelpers('bankAccount').setValue('')
      formikProps.getFieldHelpers('bankName').setValue('')
      formikProps.getFieldHelpers('budgetUnitCode').setValue('')
    }

    const taxInfo = document_data.tax_informations[0]
    console.log('taxInfo', taxInfo)
    formikProps
      .getFieldHelpers('address')
      .setValue(taxInfo.company_information.address ?? '')
    formikProps
      .getFieldHelpers('name')
      .setValue(taxInfo.company_information.official_name ?? '')
  }

  const TYPE = {
    GET: 'GET',
    REFRESH: 'REFRESH',
  }

  return (
    <div>
      <Formik
        initialValues={{
          businessBranchCode: businessBranchItem
            ? businessBranchItem.businessBranchCode
            : '',
          businessBranchName: businessBranchItem
            ? businessBranchItem.businessBranchName
            : '',
          businessBranchAddress: businessBranchItem
            ? businessBranchItem?.businessBranchAddress
            : '',
          statusUsed: businessBranchItem
            ? businessBranchItem?.statusUsed
            : null,
        }}
        validationSchema={Yup.object({
          businessBranchCode: Yup.string()
            .trim()
            .required(t('Required'))
            .max(5, t('Mã địa điểm kinh doanh tối đa 5 ký tự')),
          businessBranchName: Yup.string()
            .trim()
            .required(t('Required'))
            .max(400, t('Tên địa điểm kinh doanh tối đa 400 ký tự')),
          businessBranchAddress: Yup.string()
            .trim()
            .required(t('Required'))
            .max(400, t('Địa chỉ địa điểm kinh doanh tối đa 400 ký tự')),
        })}
        enableReinitialize
        onSubmit={(values) => {
          mutate(values)
        }}
      >
        {(formikProps) => (
          <>
            <Modal
              className=""
              show={show}
              backdrop="static"
              size="lg"
              onHide={handleClose}
              centered
              onExit={() => {
                formikProps.handleReset()
              }}
              onExited={() => {
                handleExistDone()
              }}
            >
              <Modal.Header className="px-5 py-5">
                <Modal.Title>
                  {active === 'ADD'
                    ? 'Thêm địa điểm kinh doanh'
                    : active === 'EDIT'
                      ? 'Chỉnh sửa thông tin địa điểm kinh doanh'
                      : 'Nhân bản địa điểm kinh doanh'}
                </Modal.Title>
                <div
                  className="btn btn-xs btn-icon btn-light btn-hover-secondary cursor-pointer"
                  onClick={() => {
                    handleClose()
                  }}
                >
                  <i className="far fa-times"></i>
                </div>
              </Modal.Header>

              <Modal.Body
                className="overflow-auto bg-light"
                style={{
                  maxHeight: '40vh',
                }}
              >
                <div className="row">
                  <div className="">
                    <KTFormGroup
                      label={
                        <>
                          {t('Mã địa điểm kinh doanh')}{' '}
                          <span className="text-danger">(*)</span>
                        </>
                      }
                      inputName="businessBranchCode"
                      inputElement={
                        <FastField name="businessBranchCode">
                          {({ field, form, meta }) => (
                            <KTFormInput
                              disabled={active === 'EDIT'}
                              name={field.name}
                              value={field.value}
                              onChange={(value) => {
                                form.setFieldValue(field.name, value)
                              }}
                              onBlur={() => {
                                form.setFieldTouched(field.name, true)
                              }}
                              enableCheckValid
                              isValid={_.isEmpty(meta.error)}
                              isTouched={meta.touched}
                              feedbackText={meta.error}
                              type={KTFormInputType.text}
                              placeholder={`${_.capitalize(
                                t('Mã địa điểm kinh doanh'),
                              )}...`}
                              // disabled={!canEdit}
                            />
                          )}
                        </FastField>
                      }
                    />
                  </div>

                  {/* ten khach hàng */}
                  <div className="">
                    <KTFormGroup
                      label={
                        <>
                          {t('Tên địa điểm kinh doanh')}{' '}
                          <span className="text-danger">(*)</span>
                        </>
                      }
                      inputName="businessBranchName"
                      inputElement={
                        <FastField name="businessBranchName">
                          {({ field, form, meta }) => (
                            <KTFormInput
                              name={field.name}
                              value={field.value}
                              onChange={(value) => {
                                form.setFieldValue(field.name, value)
                              }}
                              onBlur={() => {
                                form.setFieldTouched(field.name, true)
                              }}
                              enableCheckValid
                              isValid={_.isEmpty(meta.error)}
                              isTouched={meta.touched}
                              feedbackText={meta.error}
                              type={KTFormInputType.text}
                              placeholder={`${_.capitalize(
                                t('Tên địa điểm kinh doanh'),
                              )}...`}
                              // disabled={!canEdit}
                            />
                          )}
                        </FastField>
                      }
                    />
                  </div>

                  {/* dia chi */}
                  <div className="col-12">
                    <KTFormGroup
                      label={
                        <>
                          {t('Địa chỉ')}
                          <span className="text-danger">(*)</span>
                        </>
                      }
                      inputName="businessBranchAddress"
                      inputElement={
                        <FastField name="businessBranchAddress">
                          {({ field, form, meta }) => (
                            <KTFormInput
                              name={field.name}
                              value={field.value}
                              onChange={(value) => {
                                form.setFieldValue(field.name, value)
                              }}
                              onBlur={() => {
                                form.setFieldTouched(field.name, true)
                              }}
                              enableCheckValid
                              isValid={_.isEmpty(meta.error)}
                              isTouched={meta.touched}
                              feedbackText={meta.error}
                              type={KTFormInputType.text}
                              placeholder={`${_.capitalize(t('Địa chỉ'))}...`}
                              // disabled={!canEdit}
                            />
                          )}
                        </FastField>
                      }
                    />
                  </div>
                </div>
              </Modal.Body>

              <Modal.Footer>
                <div className="w-100 d-flex flex-wrap gap-3 justify-content-between">
                  <div>
                    <FastField name="statusUsed">
                      {({ field, form }) => (
                        <VIToggleSwitch
                          label={
                            field.value === 'ACTIVE'
                              ? 'Được sử dụng'
                              : 'Chưa được sử dụng'
                          }
                          status={field.value === 'ACTIVE' ? true : false}
                          name={field.name}
                          onSwitch={(checked) => {
                            if (checked) {
                              form.setFieldValue(field.name, 'ACTIVE')
                            } else {
                              form.setFieldValue(field.name, 'INACTIVE')
                            }
                          }}
                        />
                      )}
                    </FastField>
                  </div>

                  <div className="d-flex">
                    <Button
                      className="font-weight-bold  mr-3"
                      variant="secondary"
                      onClick={() => {
                        handleClose()
                      }}
                    >
                      {t('Close')}
                    </Button>

                    <Button
                      className="font-weight-bold "
                      variant="primary"
                      onClick={() => {
                        formikProps.handleSubmit()
                      }}
                    >
                      {t('Save')}
                    </Button>
                  </div>
                </div>
              </Modal.Footer>
            </Modal>
          </>
        )}
      </Formik>
    </div>
  )
}

const ButtonGetCompanyProfile = ({ taxCode, setFieldValue }) => {
  const { mutateAsync: handleGetCompanyTaxInfo, isPending: isLoading } =
    useMutationGetCompanyInfo()
  const handleOnClicked = async () => {
    const result = await handleGetCompanyTaxInfo({
      document_type: 'TAX',
      tax_code: taxCode,
    })
    if (!result) return
    const { document_data, message } = result.data
    if (message !== 'SUCCESSFULLY') {
      setFieldValue('name', '')
      setFieldValue('address', '')
    } else {
      setFieldValue(
        'name',
        document_data.tax_informations[0].company_information.official_name,
      )
      setFieldValue(
        'address',
        document_data.tax_informations[0].company_information.address,
      )
    }
  }

  return (
    <CustomAntButton
      text="Lấy thông tin"
      // iconCn={'fa-light fa-globe'}
      // iconCn={'fa-light'}
      isLoading={isLoading}
      antProps={{
        type: 'primary',
        className: 'btn btn-success mt-8 flex-grow-1',
        onClick: handleOnClicked,
      }}
      customStyle={{
        height: '38px',
      }}
    />
  )
}

export default ModalEditBusnessBranch
